module.exports = __webpack_public_path__ + "img/9-1_05.99becb95.jpg";